var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEth3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 792.2 1269"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4d465a",
    d: "M396 1269V945L0 711l396 558z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#aca9b4",
    d: "M396 1269V945l396.2-234L396 1269zM396 0v477l396 180L396 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d465a",
    d: "M396 0L0 657l396-180V0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#534d5f",
    d: "M396 477l396 180-396 234V477z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#282138",
    d: "M0 657l396-180v414L0 657z"
  })));
}

export default __webpack_public_path__ + "static/media/ETH3.f8bb3125a3a76c62c1d05881799a17cc.svg";
export { SvgEth3 as ReactComponent };